import { RouterProvider } from 'react-router-dom';

// project import
import router from 'routes';
import ThemeCustomization from 'themes';

import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';



// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

const App = () => {
  return (
    <ThemeCustomization>
      <RTLLayout>
          <ScrollTop>
              <>
                  <RouterProvider router={router} />
                 
              </>
          </ScrollTop>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;